import React from 'react';
import './NotFound.css';
import { Link } from 'react-router-dom';
import { useAppContext } from '../providers/AppContext';

export default function NotFound({
  message = 'このページは見つかりませんでした。',
  showGoBackButton = true,
}) {
  const context = useAppContext();

  return (
    <div className={'not-found'}>
      <div>
        <h4>{message}</h4>
        {showGoBackButton && context.appConfig.showStudyList && (
          <h5>
            <Link to={'/'}>ホーム画面に戻る</Link>
          </h5>
        )}
      </div>
    </div>
  );
}
